import pluralize from "pluralize"

/**
 * Get a single relationship form the store
 *
 * @export
 * @param {JsonApi.RelationshipData} data
 * @param {*} [rootGetters={}]
 * @returns
 */
export function getRelationship(
  data: JsonApi.RelationshipData,
  rootGetters: any = {},
  getterOverrides: { [type: string]: string } = {}
) {
  const { type, id } = data

  const pluralizedType = pluralize(type)

  const override = getterOverrides[pluralizedType]

  const getter = rootGetters[override ? override : `${pluralizedType}/resourceById`]

  if (getter) {
    return { ...data, ...getter(id) }
  }

  console.warn(`Attempted to use getter "${pluralize(type)}/resourceById" which doesn't exist`)

  return data
}
